import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const bookingService = {
  createBooking: async (bookingData) => {
    console.log('Creating booking with data:', bookingData);
    console.log('API URL:', `${API_BASE_URL}/bookings`);
    const token = localStorage.getItem('accessToken');
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    try {
      const response = await axios.post(
        `${API_BASE_URL}/bookings`,
        bookingData,
        config
      );
      console.log('Booking created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Booking creation error:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      if (error.response?.data?.errors) {
        console.error('Validation errors:', JSON.stringify(error.response.data.errors, null, 2));
      }
      throw error;
    }
  },

  getBookingById: async (id) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/bookings/${id}`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('Get booking by ID error:', error);
      throw error;
    }
  },

  getBookingByReference: async (reference) => {
    const response = await axios.get(`${API_BASE_URL}/bookings/reference/${reference}`);
    return response.data;
  },

  getUserBookings: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/bookings/my-bookings`, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('Get my bookings error:', error);
      throw error;
    }
  },

  cancelBooking: async (id, reason) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/bookings/${id}/cancel`,
        { reason },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      console.error('Cancel booking error:', error);
      throw error;
    }
  },
};

export default bookingService;

